import { Component } from '@angular/core'

@Component({
  selector: 'ld-layout',
  template: require('./layout.component.html'),
  styles: [require('./layout.component.css')]
})
export class LayoutComponent {}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/components/layout/layout.component.ts